import { render, staticRenderFns } from "./FreeCellsPopup.vue?vue&type=template&id=897a1ce2&scoped=true"
import script from "./FreeCellsPopup.vue?vue&type=script&lang=js"
export * from "./FreeCellsPopup.vue?vue&type=script&lang=js"
import style0 from "./FreeCellsPopup.vue?vue&type=style&index=0&id=897a1ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897a1ce2",
  null
  
)

export default component.exports